import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import http from './utils/http'
import {_import, formatDate, formatDateStr, getDictLabel} from './utils/application'
import {IsPC} from './utils/resize'
import './utils/element'
import './utils/modal'
import AppLink from './components/AppLink'
import VueAwesomeSwiper from "vue-awesome-swiper"
import 'swiper/css/swiper.css'

let isPC = IsPC();

Vue.config.productionTip = false

Vue.component("AppLink", AppLink);
Vue.use(VueAwesomeSwiper);

Vue.prototype.$http = http;
Vue.prototype.$import = _import;
Vue.prototype.$formatDate = formatDate;
Vue.prototype.$formatDateStr = formatDateStr;
Vue.prototype.$getDictLabel = getDictLabel;
Vue.prototype.$isPC = isPC;

router.beforeEach((to, from, next) => {
	if(!isPC) {
		next({
			path: '/empty/phone',
			replace: true
		});
	}else {
		next();
	}
})

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
